import React from "react";
import { motion } from "framer-motion";

const STATIONS = [
  { label: "Today", meta: "Present", status: "live" },
  { label: "Smart Electronics", meta: "LED · Power Electronics", status: "live" },
  { label: "Engineering Services", meta: "Design · Integration", status: "live" },
  { label: "Industrial Solutions", meta: "Automation · Turnkey", status: "live" },
  { label: "Debsun Genesys", meta: "Digital Platform", status: "dev" },
  { label: "LYNDA", meta: "Intelligent Systems", status: "research" },
  { label: "Future Intelligent Engineering Systems", meta: "Horizon", status: "vision" },
];

const DOT = { live: "var(--teal)", dev: "var(--gold)", research: "var(--purple)", vision: "var(--steel)" };

export default function Roadmap() {
  return (
    <section id="roadmap" className="relative py-20 sm:py-28 lg:py-36 scroll-mt-[88px]" data-testid="roadmap">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20">
          <div className="lg:col-span-6">
            <div className="sec-index mb-4">05 — Trajectory</div>
            <h2 className="display display-section text-4xl md:text-6xl">The <span style={{ color: "var(--gold)" }}>track</span> ahead.</h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-base md:text-lg text-steel-text leading-relaxed">
              One line, laid deliberately — from the products we ship today toward the intelligent
              engineering systems of the future. Every station is a real milestone, not a promise.
            </p>
          </div>
        </div>

        {/* Railway timeline */}
        <div className="relative max-w-4xl mx-auto">
          {/* center rails */}
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 flex gap-1.5" aria-hidden="true">
            <div className="w-px rail-line" />
            <div className="w-px rail-line" />
          </div>
          {/* ties */}
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-8 rail-tie" aria-hidden="true" />

          <div className="relative space-y-14">
            {STATIONS.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, x: left ? -40 : 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
                  className={`relative flex ${left ? "justify-start" : "justify-end"}`}
                  data-testid={`roadmap-station-${i}`}
                >
                  {/* node */}
                  <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-10">
                    <span className="block w-4 h-4 rotate-45 border-2 bg-background" style={{ borderColor: DOT[s.status] }} />
                  </div>

                  <div className={`w-[calc(50%-40px)] ${left ? "pr-10 text-right" : "pl-10 text-left"}`}>
                    <div className="steel-card clip-frame-sm inline-block text-left p-6 min-w-[220px]">
                      <div className="flex items-center gap-2 mb-2" style={{ justifyContent: left ? "flex-end" : "flex-start" }}>
                        <span className="w-1.5 h-1.5 rounded-full" style={{ background: DOT[s.status] }} />
                        <span className="font-mono-2 text-[9px] tracking-[0.25em] uppercase text-muted-foreground">{s.meta}</span>
                      </div>
                      <div className="display display-section text-xl md:text-2xl">{s.label}</div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
